import { Button, Card, CardContent, CardFooter, CardHeader, CardTitle } from "@diametral/design-system/react";

import { Trans, useTranslation } from "../lib/i18n";
import { keycloak, logout } from "../lib/keycloak";

/** 403 « compte non relié » : the SSO account matches no Boond person (and is not DAR). */
export function NotLinkedPage({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation();
  const token = keycloak.tokenParsed as { email?: string; name?: string } | undefined;
  return (
    <main className="ada-full-screen">
      <Card>
        <CardHeader>
          <p className="ds-kicker">ada</p>
          <CardTitle>{t("Account not linked")}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="ada-stack">
            <p>{t("Your account is not linked to any Boond person, contact the DAR.")}</p>
            {token?.email ? (
              <p className="ada-muted">
                <Trans
                  i18nKey="Signed-in account: <strong>{{email}}</strong>. The resource allocation office can link it to your record (Administration › People › Unlinked accounts)."
                  values={{ email: token.email }}
                  components={{ strong: <strong /> }}
                />
              </p>
            ) : null}
          </div>
        </CardContent>
        <CardFooter>
          <div className="ada-cluster">
            {onRetry ? (
              <Button variant="outline" onClick={onRetry}>
                {t("Try again")}
              </Button>
            ) : null}
            <Button variant="primary" onClick={logout}>
              {t("Sign out")}
            </Button>
          </div>
        </CardFooter>
      </Card>
    </main>
  );
}
